(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.apheumGalleryReady === 'true') return;
    root.dataset.apheumGalleryReady = 'true';

    var sectionId = root.getAttribute('data-section-id');
    var jsonEl = root.querySelector('[data-apheum-gallery-json]');
    if (!sectionId || !jsonEl) return;

    var raw = [];
    try { raw = JSON.parse(jsonEl.textContent || '[]'); } catch (error) { return; }

    var images = raw.map(function (value) {
      try { return atob(value); } catch (error) { return value; }
    }).filter(Boolean);
    if (!images.length) return;

    var active = 0;
    var viewerIP = '';
    var blocked = false;
    var modifierHeld = false;
    var verified = false;
    var lightboxOpen = false;
    var creditText = jsonEl.getAttribute('data-credit') || '';
    var MAX_PX = 420;
    var MAX_PX_LIGHTBOX = 1100;
    var isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    var $ = function (selector) { return root.querySelector(selector); };

    var canvas = $('[data-apheum-canvas]');
    var display = $('[data-apheum-display]');
    var loader = $('[data-apheum-loader]');
    var counter = $('[data-apheum-counter]');
    var thumbsWrap = $('[data-apheum-thumbs]');
    var viewer = $('[data-apheum-viewer]');
    var blockEl = $('[data-apheum-blocked]');
    var protectedArea = $('[data-apheum-protected]');
    var zoomButton = $('[data-apheum-zoom]');

    var lightbox = document.getElementById('apheum-lb-' + sectionId);
    var lightboxCanvas = lightbox ? lightbox.querySelector('[data-apheum-lb-canvas]') : null;
    var lightboxDisplay = lightbox ? lightbox.querySelector('[data-apheum-lb-display]') : null;
    var lightboxCounter = lightbox ? lightbox.querySelector('[data-apheum-lb-counter]') : null;

    if (!canvas || !display || !loader || !counter || !thumbsWrap || !viewer || !blockEl || !protectedArea) return;
    if (lightbox && lightbox.parentNode !== document.body) document.body.appendChild(lightbox);

    function lockDown() {
      if (blocked) return;
      blocked = true;
      blockEl.classList.add('is-active');
      protectedArea.classList.add('is-locked');
      viewer.style.display = 'none';
      closeLightbox();
    }

    function checkSize() {
      if (isMobile) return;
      if (window.outerWidth - window.innerWidth > 160 || window.outerHeight - window.innerHeight > 160) lockDown();
    }

    function checkConsole() {
      if (isMobile) return;
      try {
        var element = new Image();
        Object.defineProperty(element, 'id', { get: function () { lockDown(); } });
        console.log('%c', element);
      } catch (error) {}
    }

    function blockDevKeys(event) {
      if (
        event.key === 'F12' ||
        (event.ctrlKey && event.shiftKey && ['I', 'J', 'C'].indexOf(event.key) !== -1) ||
        (event.metaKey && event.altKey && ['I', 'J', 'C'].indexOf(event.key) !== -1) ||
        (event.ctrlKey && event.key === 'u') ||
        (event.metaKey && event.key === 'u')
      ) {
        event.preventDefault();
        event.stopPropagation();
        lockDown();
      }
    }

    checkSize();
    checkConsole();
    setInterval(function () { checkSize(); checkConsole(); }, 1500);
    window.addEventListener('resize', checkSize);
    window.addEventListener('keydown', blockDevKeys, true);

    protectedArea.addEventListener('copy', function (event) { event.preventDefault(); });
    protectedArea.addEventListener('selectstart', function (event) { event.preventDefault(); });
    protectedArea.addEventListener('contextmenu', function (event) { event.preventDefault(); });
    thumbsWrap.addEventListener('contextmenu', function (event) { event.preventDefault(); });
    thumbsWrap.querySelectorAll('img').forEach(function (image) {
      image.setAttribute('draggable', 'false');
      image.style.webkitTouchCallout = 'none';
    });

    var screenshotBackup = null;
    var screenshotLightboxBackup = null;
    var screenshotTimer = null;
    var screenshotLockUntil = 0;
    var needsInteraction = false;

    function screenshotHide() {
      modifierHeld = true;
      if (!screenshotBackup && display.style.backgroundImage && display.style.backgroundImage !== 'none') {
        screenshotBackup = display.style.backgroundImage;
        display.style.backgroundImage = 'none';
      }
      if (lightboxOpen && lightboxDisplay && !screenshotLightboxBackup && lightboxDisplay.style.backgroundImage && lightboxDisplay.style.backgroundImage !== 'none') {
        screenshotLightboxBackup = lightboxDisplay.style.backgroundImage;
        lightboxDisplay.style.backgroundImage = 'none';
      }
      clearTimeout(screenshotTimer);
    }

    function screenshotRestore(delay) {
      if (Date.now() < screenshotLockUntil) return;
      clearTimeout(screenshotTimer);
      screenshotTimer = setTimeout(function () {
        if (Date.now() < screenshotLockUntil) return;
        modifierHeld = false;
        if (screenshotBackup) {
          display.style.backgroundImage = screenshotBackup;
          screenshotBackup = null;
        }
        if (screenshotLightboxBackup && lightboxDisplay) {
          lightboxDisplay.style.backgroundImage = screenshotLightboxBackup;
          screenshotLightboxBackup = null;
        }
      }, delay || 300);
    }

    function screenshotLockAndHide(milliseconds) {
      screenshotHide();
      screenshotLockUntil = Date.now() + milliseconds;
      clearTimeout(screenshotTimer);
      screenshotTimer = setTimeout(function () {
        screenshotLockUntil = 0;
        modifierHeld = false;
        if (screenshotBackup) {
          display.style.backgroundImage = screenshotBackup;
          screenshotBackup = null;
        }
        if (screenshotLightboxBackup && lightboxDisplay) {
          lightboxDisplay.style.backgroundImage = screenshotLightboxBackup;
          screenshotLightboxBackup = null;
        }
      }, milliseconds);
    }

    function clobberClipboard() {
      try {
        var tinyCanvas = document.createElement('canvas');
        tinyCanvas.width = 1;
        tinyCanvas.height = 1;
        tinyCanvas.toBlob(function (blob) {
          if (blob && navigator.clipboard && navigator.clipboard.write && typeof ClipboardItem !== 'undefined') {
            navigator.clipboard.write([new ClipboardItem({ 'image/png': blob })]).catch(function () {});
          }
        });
      } catch (error) {}
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Meta' || event.key === 'OS' || event.key === 'Shift' || event.metaKey || event.shiftKey) screenshotHide();
      if (event.key === 'PrintScreen' || event.key === 'Snapshot') {
        screenshotHide(); clobberClipboard(); screenshotLockAndHide(1500);
      }
      if ((event.metaKey || event.key === 'Meta' || event.key === 'OS') && event.shiftKey && (event.key === 's' || event.key === 'S')) screenshotLockAndHide(8000);
      if (event.ctrlKey && event.shiftKey && (event.key === 's' || event.key === 'S')) screenshotLockAndHide(8000);
    }, true);

    document.addEventListener('keyup', function (event) {
      if (event.key === 'PrintScreen' || event.key === 'Snapshot') {
        screenshotHide(); clobberClipboard(); screenshotLockAndHide(1500);
      }
      if (event.key === 'Meta' || event.key === 'OS' || event.key === 'Shift') {
        needsInteraction = false;
        screenshotRestore(300);
      }
    }, true);

    protectedArea.addEventListener('click', function (event) {
      if (event.metaKey || event.shiftKey || modifierHeld) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    }, true);

    document.addEventListener('visibilitychange', function () { if (document.hidden) screenshotHide(); });
    window.addEventListener('blur', function () { screenshotHide(); needsInteraction = true; });
    document.addEventListener('pointerdown', function (event) {
      if (!needsInteraction || event.metaKey || event.shiftKey || event.ctrlKey || !document.hasFocus()) return;
      needsInteraction = false;
      if (Date.now() >= screenshotLockUntil) screenshotRestore(150);
    });

    display.style.visibility = 'hidden';
    if (lightboxDisplay) lightboxDisplay.style.visibility = 'hidden';

    function markVerified() {
      verified = true;
      display.style.visibility = 'visible';
      if (lightboxDisplay) lightboxDisplay.style.visibility = 'visible';
      document.removeEventListener('pointermove', verify);
      document.removeEventListener('pointerdown', verify);
    }

    function verify(event) {
      if (verified) return;
      if (!event.metaKey && !event.shiftKey && !event.ctrlKey) markVerified();
    }

    document.addEventListener('pointermove', verify);
    document.addEventListener('pointerdown', verify);

    fetch('https://api.ipify.org?format=text', { headers: { Accept: 'text/plain' } })
      .then(function (response) {
        if (!response.ok) throw new Error('IP lookup failed');
        return response.text();
      })
      .then(function (ip) { viewerIP = (ip || '').trim() || 'IP verborgen'; renderMain(); })
      .catch(function () { viewerIP = 'IP verborgen'; renderMain(); });

    function utc() {
      var date = new Date();
      return date.getUTCFullYear() + '-' + String(date.getUTCMonth() + 1).padStart(2, '0') + '-' + String(date.getUTCDate()).padStart(2, '0') + ' ' + String(date.getUTCHours()).padStart(2, '0') + ':' + String(date.getUTCMinutes()).padStart(2, '0') + ':' + String(date.getUTCSeconds()).padStart(2, '0') + ' UTC';
    }

    function addNoise(context, width, height) {
      var data = context.getImageData(0, 0, width, height);
      var pixels = data.data;
      for (var i = 0; i < pixels.length; i += 4) {
        var noise = (Math.random() - 0.5) * 4;
        var value = Math.min(255, Math.max(0, pixels[i] + noise));
        pixels[i] = value; pixels[i + 1] = value; pixels[i + 2] = value;
      }
      context.putImageData(data, 0, 0);
    }

    function addCredit(context, width, height) {
      if (!creditText) return;
      context.save();
      context.font = "600 11px -apple-system,'Segoe UI',sans-serif";
      var textWidth = context.measureText(creditText).width;
      var padding = 10;
      var boxWidth = textWidth + padding * 2;
      var boxHeight = 26;
      var x = 8;
      var y = height - boxHeight - 8;
      context.fillStyle = 'rgba(0,0,0,.5)';
      if (context.roundRect) {
        context.beginPath(); context.roundRect(x, y, boxWidth, boxHeight, 10); context.fill();
      } else {
        context.fillRect(x, y, boxWidth, boxHeight);
      }
      context.fillStyle = 'rgba(255,255,255,.85)';
      context.textAlign = 'left';
      context.textBaseline = 'middle';
      context.fillText(creditText, x + padding, y + boxHeight / 2);
      context.restore();
    }

    function addWatermark(context, width, height) {
      var text = (viewerIP || '…') + '  ·  ' + utc();
      context.save();
      context.font = "500 11px -apple-system,'Segoe UI',sans-serif";
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      var columns = 3;
      var rows = 2;
      for (var row = 1; row <= rows; row++) {
        for (var column = 1; column <= columns; column++) {
          context.save();
          context.translate(width / (columns + 1) * column, height / (rows + 1) * row);
          context.rotate(-Math.PI / 4);
          context.fillStyle = 'rgba(255,255,255,.28)';
          context.fillText(text, 0, 0);
          context.restore();
        }
      }
      context.restore();
    }

    function draw(src, targetCanvas, targetDisplay, maxPixels, watermark, explicitSize, done) {
      var image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = function () {
        var viewportWidth = explicitSize ? Math.max(240, window.innerWidth - 180) : maxPixels;
        var viewportHeight = explicitSize ? Math.max(240, window.innerHeight - 190) : maxPixels;
        var scale = Math.min(maxPixels / image.width, maxPixels / image.height, viewportWidth / image.width, viewportHeight / image.height, 1);
        targetCanvas.width = Math.max(1, Math.round(image.width * scale));
        targetCanvas.height = Math.max(1, Math.round(image.height * scale));
        var context = targetCanvas.getContext('2d');
        context.drawImage(image, 0, 0, targetCanvas.width, targetCanvas.height);
        addNoise(context, targetCanvas.width, targetCanvas.height);
        if (watermark) addWatermark(context, targetCanvas.width, targetCanvas.height);
        addCredit(context, targetCanvas.width, targetCanvas.height);
        var url = targetCanvas.toDataURL('image/png');
        targetDisplay.style.backgroundImage = 'url("' + url + '")';
        targetDisplay.style.aspectRatio = targetCanvas.width + ' / ' + targetCanvas.height;
        if (explicitSize) {
          targetDisplay.style.width = targetCanvas.width + 'px';
          targetDisplay.style.height = targetCanvas.height + 'px';
          targetDisplay.style.maxWidth = 'calc(100vw - 180px)';
          targetDisplay.style.maxHeight = 'calc(100vh - 190px)';
        }
        if (verified) targetDisplay.style.visibility = 'visible';
        if (done) done(true);
      };
      image.onerror = function () { if (done) done(false); };
      image.src = src;
    }

    function renderMain() {
      if (blocked) return;
      counter.textContent = (active + 1) + ' / ' + images.length;
      loader.classList.add('is-loading');
      draw(images[active], canvas, display, MAX_PX, false, false, function () { loader.classList.remove('is-loading'); });
      updateThumbs();
    }

    function updateThumbs() {
      thumbsWrap.querySelectorAll('[data-apheum-thumb]').forEach(function (button) {
        button.classList.toggle('apheum-viewer__thumb--active', parseInt(button.getAttribute('data-apheum-thumb'), 10) === active);
      });
    }

    function renderLightbox() {
      if (!lightboxCanvas || !lightboxDisplay || !lightboxCounter) return;
      lightboxCounter.textContent = (active + 1) + ' / ' + images.length;
      draw(images[active], lightboxCanvas, lightboxDisplay, MAX_PX_LIGHTBOX, true, true);
    }

    function previous() {
      active = (active - 1 + images.length) % images.length;
      renderMain();
      if (lightboxOpen) renderLightbox();
    }

    function next() {
      active = (active + 1) % images.length;
      renderMain();
      if (lightboxOpen) renderLightbox();
    }

    var previousButton = $('[data-apheum-nav="prev"]');
    var nextButton = $('[data-apheum-nav="next"]');
    if (previousButton) previousButton.addEventListener('click', previous);
    if (nextButton) nextButton.addEventListener('click', next);

    thumbsWrap.addEventListener('click', function (event) {
      var button = event.target.closest('[data-apheum-thumb]');
      if (!button || modifierHeld) return;
      active = parseInt(button.getAttribute('data-apheum-thumb'), 10);
      renderMain();
      if (lightboxOpen) renderLightbox();
    });

    function openLightbox() {
      if (!lightbox || modifierHeld || blocked || isMobile) return;
      markVerified();
      lightboxOpen = true;
      lightbox.classList.add('is-open');
      document.documentElement.classList.add('apheum-art-lightbox-open');
      renderLightbox();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightboxOpen = false;
      lightbox.classList.remove('is-open');
      document.documentElement.classList.remove('apheum-art-lightbox-open');
    }

    if (zoomButton) zoomButton.addEventListener('click', openLightbox);
    if (lightbox) {
      lightbox.querySelectorAll('[data-apheum-lb-close]').forEach(function (element) { element.addEventListener('click', closeLightbox); });
      var lightboxPrevious = lightbox.querySelector('[data-apheum-lb-prev]');
      var lightboxNext = lightbox.querySelector('[data-apheum-lb-next]');
      if (lightboxPrevious) lightboxPrevious.addEventListener('click', previous);
      if (lightboxNext) lightboxNext.addEventListener('click', next);
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') previous();
      if (event.key === 'ArrowRight') next();
      if (event.key === 'Escape' && lightboxOpen) closeLightbox();
    });

    renderMain();
  }

  function start() {
    document.querySelectorAll('[data-apheum-protected-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
